import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { redMui } from "@ryde/theme";

export const ErrorsDisplayItemStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "errors-display-item",
})`
  display: flex;
  font-weight: 400;
  font-size: 14px;
  padding: 4px;
  color: ${redMui.A700};
  svg {
    margin-inline-end: 10px;
    align-self: center;
    width: 15px;
  }
`;

export const ErrorsDisplayContainerStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "errors-display-container",
  },
)<{ $marginLeft?: string | undefined }>`
  background: ${redMui._50};
  margin-top: 5px;
  margin-bottom: 5px;
  padding-top: 7px;
  padding-bottom: 7px;
  border-radius: 3px;
  padding-inline-start: 7px;
  padding-inline-end: 3px;
  margin-inline-start: ${props =>
    props.$marginLeft ? props.$marginLeft : "0"};
  margin-inline-end: 0;
`;
